import { useTranslation } from 'react-i18next';
import { Textarea } from '@/components/ui/textarea';

interface FieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  type?: string;
  pattern?: string;
  readOnly?: boolean;
  hint?: string;
}

export function TextField({ label, value, onChange, placeholder, required, type = 'text', pattern, readOnly, hint }: FieldProps) {
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-foreground">
        {label}
        {required && <span className="ml-0.5 text-destructive">*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        pattern={pattern}
        readOnly={readOnly}
        className="w-full rounded-lg border border-border bg-card px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors disabled:opacity-60 read-only:bg-muted read-only:text-muted-foreground"
      />
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}

interface BriefingProps {
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  required?: boolean;
}

export function BriefingField({ value, onChange, rows = 10, required }: BriefingProps) {
  const { t } = useTranslation();
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-foreground">
        {t('superuser.catalog.form.briefing', { defaultValue: 'Briefing (descripción inyectada al agente IA)' })}
        {required && <span className="ml-0.5 text-destructive">*</span>}
      </label>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        className="min-h-[12rem]"
        required={required}
      />
    </div>
  );
}
